import {documentReady} from "@morningtrain/helpers";

export default function DocumentReadyPlugin(app) {

    if (app.env.client() === false) {
        return Promise.resolve();
    }

    return documentReady();
}
